import { queryCommonFlags } from "@/api/constants";
import { getPartnersWithMethodOfContactV2 } from "@/modules/leads/api/index.v2";
import { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";

const usePartnersWithMethodOfContact = (methodOfContactId?: string) => {
  const pageSize = 20;
  const [page, setPage] = useState(1);
  const [partnersSearch, setPartnersSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedPartner, setSelectedPartner] = useState<string | null>(null);
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      setDebouncedSearch(partnersSearch.trim());
    }, 500);

    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, [partnersSearch]);

  const { data: partnersData, isFetching: partnersLoading } = useQuery(
    [
      "getPartnersWithMethodOfContact",
      methodOfContactId,
      page,
      debouncedSearch || "",
    ],
    () =>
      getPartnersWithMethodOfContactV2({
        methodOfContact: methodOfContactId,
        page,
        pageSize,
        ...(debouncedSearch ? { search: debouncedSearch } : {}),
      }),
    {
      enabled: !!methodOfContactId,
      keepPreviousData: true,
      ...queryCommonFlags,
    }
  );

  return {
    partnersData,
    partnersSearch,
    selectedPartner,
    partnersLoading,
    setSelectedPartner,
    setPartnersSearch,
    setPage,
  };
};

export default usePartnersWithMethodOfContact;
